import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  passwordPattern = /^.(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^&*()_-]).{7,}$/;
  // emailPattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  emailPattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.(\w)+$/;
  decimalPattern = /^\d+(\.\d+)?$/;
  // emailDomainPattern = /\.(com|co)$/
  // emailPattern = (/^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*\\\$/);
  numerical = '^[0-9]*$';
  // percentage = '^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$';
  percentage = /^\d+(\.\d+)?%?$/ ;
  float=/^[+-]?\d+(\.\d+)?$/
  // urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
  urlPattern =/^((https?:\/\/)?((?!www\.)[a-z0-9-]+\.){1,}([a-z]{2,6})(\/[\/\w \.-]*)*\/?)|(www\.[a-z0-9-]+\.[a-z]{2,6}(\/[\/\w \.-]*)*\/?)$/;
  facebookPattern = /http(?:s):\/\/(?:www\.)facebook\.com\/.+/i;
  googlePattern = /http(?:s):\/\/(?:www\.)google\.com\/.+/i;
  yelpPattern = /http(?:s):\/\/biz.yelp\.com\/.+/i;
  // alphaPattern = /^(?:[a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF])){0,25}$/;
  preventSpaces = "^[A-Za-z][A-Za-z0-9]*$";
  webSiteValidation = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
  phonePattern = /^(\([0-9]{3}\) |[0-9]{3})[0-9]{3}-[0-9]{4,5}$/;
  zipCodePattern = /\b\d{5}\b/;
  alphaPattern = /^(?:[-a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF]))+$/;
  subdomainPattern = /^(?!:\/\/)([a-zA-Z0-9][a-zA-Z0-9-]{0,61})+[a-zA-Z0-9]$/;


  // ***** password validations
  passwordLettersPattern = /[A-Za-z]/;
  passwordCapitalLetterPatter = /[A-Z]/;
  passwordSmallLetterPatter = /[a-z]/;
  passwordNumbersPattern = /\d/;
  passwordSpecialCharPattern = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
  HexColorPattern = /^[A-Fa-f0-9]{6}$|^[A-Fa-f0-9]{3}$/;
  validPhoneUS = /\(\d{3}\) \d{3}-\d{4}/;
  validFax = /\(\d{3}\) \d{3}-\d{4}/;
  hexadecimalColor = /^#[0-9A-Fa-f]{6}$/
  constructor() { }


  matchingPasswords(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isNotMatched = control.get('password')?.value !== control.get('password_confirmation')?.value;
      return isNotMatched ? { unmatchedPasswords: true } : null;
    };
  }
  patternWithMessage = (pattern: RegExp, error: ValidationErrors): ValidatorFn => {
    return (control: AbstractControl): any | null => {
      if (!control?.value) {
        return null;
      }

      return pattern.test(control?.value) ? null : error;
    }
  }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } |null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error, else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  yearRangeValidator(pastYear: number, currentYear: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null; // Return null for empty values (optional)
      }
      const inputYear = parseInt(value, 10); // Parse the input as an integer
      if (isNaN(inputYear)) {
        return { invalidYear: true }; // Return an error if the input is not a valid year
      }
      if (inputYear < pastYear || inputYear > currentYear) {
        return { yearOutOfRange: true }; // Return an error if the year is out of range
      }
      return null; // Validation passed
    };
  }
  matchingPaymentAccountNumbers(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isNotMatched = control.get('bank_account_number')?.value !== control.get('bank_account_number_confirmation')?.value;
      return isNotMatched ? { unmatchedBankAccountNumber: true } : null;
    };
  }
}
